module.exports = __webpack_public_path__ + "static/media/visual-aid-page-3.9a304c05.jpg";